import Axios from "../api/axios";
import config from "../../config";

const getIssues = () => {
  return Axios.get(`${config.BASE_URL}issues?populate=*`);
};

export default getIssues;
